export default "__VITE_ASSET__CUcNcAp1__"